<template>
  <v-dialog v-model="showVideo" persistent max-width="1000">
    <v-card>
      <div class="text-xs-right">
        <v-btn
          flat
          fab
          dark
          small
          color="grey"
          @click="$emit('input', false)"
          style="line-height: 10px"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <v-tabs v-model="active" slider-color="primary">
        <v-tab :key="'facebook'" :href="'#facebook'" ripple>Facebook</v-tab>
        <v-tab :key="'url'" :href="'#url'" ripple>{{ $t('Link') }}</v-tab>
      </v-tabs>
      <v-card-text>
        <div v-if="active == 'facebook'">
          <video-list @onSelect="addVideo"></video-list>
        </div>
        <div v-else-if="active == 'url'">
          <div class="caption">{{ $t('Link') }}</div>
          <div class="form-control" :class="{ 'has-error': errors.has('videourl') }">
            <textarea
              style="min-height: 90px"
              :placeholder="$t('Link')"
              data-vv-name="videourl"
              :data-vv-as="$t('Link')"
              v-model="videourl"
              v-validate="
                active == 'url'
                  ? {
                      required: true,
                      regex: /(\.(mp4)$|^(https:\/\/drive\.google\.com\/uc))|https:\/\/www.facebook.com\/\S*\/videos\//gim,
                    }
                  : ''
              "
            ></textarea>
            <span class="text-error" v-show="errors.has('videourl')">{{
              errors.first('videourl')
            }}</span>
          </div>

          <div class="text-xs-center">
            <v-btn depressed color="primary" @click="addVideo">{{ $t('Select') }}</v-btn>
          </div>
        </div>

        <div class="mt-4 caption">
          {{
            $t(
              'Note: Large video files are slow to download , it can cause a failure and file type must be .mp4'
            )
          }}
        </div>
        <div class="caption">{{ $t('moreover maximum file size = 25MB') }}</div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import VideoList from './VideoList'
export default {
  props: ['value'],
  data: function () {
    return {
      showVideo: this.value,

      active: null,
      videourl: null,
    }
  },
  components: {
    VideoList,
  },
  methods: {
    addVideo: function (video) {
      var vm = this
      vm.$validator.validate().then((result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }
        if (vm.active == 'facebook') {
          vm.$emit('onAddVideo', {
            source: 'https://www.facebook.com' + video.permalink_url,
            picture: video.picture,
            type: 'video',
          })
        } else if (vm.active == 'url') {
          vm.$emit('onAddVideo', { source: vm.videourl, picture: null, type: 'video' })
        }
      })
    },
  },
  watch: {
    value: function (newVal) {
      this.showVideo = newVal
    },
  },
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/intent/ModalVideo.vue